/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register } from 'swiper/element/bundle';
import Swiper from 'swiper/core';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { initFaro } from '@core/faro/faro.initializer';

Swiper.use([Navigation, Pagination, Autoplay]);

register();

initFaro();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
